// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"6a5b9c04","3091":"6a5b9c04","5472":"6a5b9c04","7266":"6a5b9c04","8153":"6a5b9c04"}[chunkId] + ".chunk.css";
};